module.exports = __webpack_public_path__ + "static/media/glass-whiskey.f98a1eba.svg";